// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { ellipsis, xScreen } from "@stanion/XDL/Utilities";
import { css } from "styled-components";

wishListCardStyles.detailLinkGridItem = {
    width: 12,
    css: css`
        height: 56px;
        ${TypographyStyle} {
            font-size: 20px;
            line-height: 28px;
            ${ellipsis(2)};
        }
    `,
};

wishListCardStyles.actionAddToCartButton = {
    color: "primary",
    css: css`
        white-space: nowrap;
        width: 100%;
        padding: 0 10px;
    `,
};

wishListCardStyles.extendedInfoGridContainer = {
    gap: 10,
    css: css`
        height: 100%;
    `,
};

wishListCardStyles.wishListInfoGridContainer = {
    gap: 10,
};

wishListCardStyles.productImagesGridItem = {
    width: [12, 12, 12, 7, 7],
    css: css`
        flex-wrap: nowrap;
    `,
};

wishListCardStyles.productImage = {
    height: "75px",
    width: "75px",
    errorTypographyProps: {
        size: 11,
        css: css`
            max-height: 65px;
        `,
    },
};

wishListCardStyles.lastUpdatedText = {
    size: 14,
    css: css`
        ${ellipsis(2)};
    `,
};

wishListCardStyles.sharingStatusGridItem = {
    width: [12, 12, 12, 5, 5],
};

wishListCardStyles.sharingStatus = {
    privateTooltip: {
        cssOverrides: {
            tooltipContainer: css`
                margin-left: -80px;
                ${xScreen("lte", "md")} {
                    margin-left: 0;
                }
                &::after {
                    margin-left: -36px;
                }
            `,
        },
    },
};

wishListCardStyles.actionAddToCartClickable = {
    css: css`
        &:disabled {
            opacity: 33%;
        }
    `,
};
